import { render, staticRenderFns } from "./SubOrdersTableAdmin.vue?vue&type=template&id=63dc2346"
import script from "./SubOrdersTableAdmin.vue?vue&type=script&lang=js"
export * from "./SubOrdersTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports